import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, SectionPad, StatTile } from "../../components/ui-extras";

export default function Reports() {
  const [margin, setMargin] = useState([]);
  const [ar, setAr] = useState({});

  useEffect(() => {
    api.get("/reports/margin").then(({ data }) => setMargin(data));
    api.get("/reports/ar-aging").then(({ data }) => setAr(data));
  }, []);

  const buckets = [
    ["current", "Current"],
    ["1_30", "1–30 days"],
    ["31_60", "31–60 days"],
    ["61_90", "61–90 days"],
    ["90_plus", "90+ days"],
  ];

  return (
    <SectionPad>
      <PageHeader title="Reports" subtitle="ANALYTICS / REPORTS" testId="reports-header" />

      <h2 className="overline mb-3">ACCOUNTS RECEIVABLE AGING</h2>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8">
        {buckets.map(([k, l]) => (
          <StatTile key={k} label={l} value={`$${(ar[k] || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`} testId={`ar-${k}`} />
        ))}
      </div>

      <h2 className="overline mb-3">MARGIN REPORT BY CUSTOMER (INVOICED)</h2>
      <div className="gf-card">
        <div className="overflow-x-auto">
          <table className="gf-table">
            <thead>
              <tr>
                <th>CUSTOMER</th>
                <th className="text-right">TRANSACTIONS</th>
                <th className="text-right">VOLUME (L)</th>
                <th className="text-right">COST</th>
                <th className="text-right">REVENUE</th>
                <th className="text-right">GROSS PROFIT</th>
                <th className="text-right">AVG MARGIN CPL</th>
              </tr>
            </thead>
            <tbody>
              {margin.map((r) => (
                <tr key={r.customer_id}>
                  <td className="font-medium">{r.customer_name}</td>
                  <td className="gf-num">{r.tx_count}</td>
                  <td className="gf-num">{r.volume.toFixed(0)}</td>
                  <td className="gf-num">${r.cost.toFixed(2)}</td>
                  <td className="gf-num">${r.revenue.toFixed(2)}</td>
                  <td className="gf-num font-semibold" style={{ color: "#16A34A" }}>${r.gross_profit.toFixed(2)}</td>
                  <td className="gf-num">{(r.avg_margin_cpl * 100).toFixed(2)}¢</td>
                </tr>
              ))}
              {margin.length === 0 && <tr><td colSpan={7} className="text-center text-zinc-400 py-8">No invoiced transactions yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </SectionPad>
  );
}
